import React from 'react';

function LandingFeatureCard(props) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white/70 p-6 shadow-sm">
      <img className="mx-auto" width="100px" src={props.imageSrc} alt={props.title} />
      <div className="my-4">
        <h4 className="text-lg font-semibold text-gray-900">{props.title}</h4>
        <span className="text-gray-600">{props.description}</span>
      </div>
    </div>
  );
}

export default LandingFeatureCard;
